import {$api} from "./index";

export const fetchStatement = async () => {
    const {data} = await $api.get('api/statement')
    return data
}

export const updateStatement = async (statement) => {
    const {data} = await $api.put('api/statement', statement)
    return data
}
